module.exports = __webpack_public_path__ + "static/media/close-Icon.ff0941e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Lightbox/close-Icon.svg
// module id = 43
// module chunks = 0